// Components
import './_quote';
import './_allTrendsPopup';
import './_allTrendsContent';
import './_maskInAnimation';
import './_textRevealAnimation';
import './_overlay';
import './_sectionalCard';
import './_carousel';
import './_trendComponent';

// Script
const trend = {
   id: 1,
   image: 'assets/img/trend_3.png',
   mockup: 'assets/img/mockup.svg',
};

const containerImage = document.getElementById('trendContainer');

if (containerImage) {
   const slide = document.createElement('div');
   slide.className = 'trend-header-slide active';
   slide.style.backgroundImage = `url(${trend.illustrationUrl})`;
   slide.innerHTML = `
                    <div class="trend-header-overlay"></div>
                    <div class="trend-header-content">
                        <img src="${trend.mockup}" alt="Trend Visual" />
                    </div>
                `;

   containerImage.appendChild(slide);
}

// next trend buttons
function nextTrendButtons() {
   const nextTrends = [
      {
         id: 1,
         title: 'Trend 1',
         image: 'assets/img/trend_1.png',
         badgeText: 'Energy',
         badgeColor: '#FF5722',
      },
      {
         id: 2,
         title: 'Trend 2',
         image: 'assets/img/trend_2.png',
         badgeText: 'HVAC',
         badgeColor: '#009688',
      },
   ];

   const container = document.getElementById('nextTrendsContainer');
   if (container) {
      nextTrends.forEach((trend) => {
         const card = document.createElement('div');
         card.className = 'next-trend-container-card';
         card.innerHTML = `
<img src="${trend.image}" alt="${trend.title}" class="bg-img">
<div class="next-trend-container-overlay-img">
    <img src="assets/img/manlogo.svg" alt="Icon">
</div>
<div class="next-trend-container-body">
<div class="next-trend-container-badge">
    <span class="badge-dot" style="background-color: ${trend.badgeColor};"></span>
    <span>${trend.badgeText}</span>
</div>
 </div>
<div class="next-trend-container-footer">
    <div class="footer-title">${trend.title}</div>
    <div class="footer-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" >
  <path d="M27.1 34.5869L26.1 33.5575L34.8 24.8075L10.5 24.8075V23.3663L34.8 23.3663L26.1 14.6163L27.1 13.5869L37.5 24.0869L27.1 34.5869Z"/>
</svg>
    </div>
  </div>
`;
         container.appendChild(card);
      });
   }
}

// side menu
function sideMenuBar() {
   window.addEventListener('load', () => {
      languageSidebar.classList.remove('open');
      wrapper.classList.add('hidden');
   });
   const openSidebarBtn = document.getElementById('openSidebarBtn');
   const closeSidebarBtn = document.getElementById('closeSidebarBtn');
   const languageSidebar = document.getElementById('languageSidebar');
   const openSidebarBtnMobile = document.getElementById('openSidebarBtnMobile');
   const wrapper = document.getElementById('languageSidebarWrapper');

   openSidebarBtn.addEventListener('click', function () {
      languageSidebar.classList.add('open');
      wrapper.classList.remove('hidden');
   });

   openSidebarBtnMobile.addEventListener('click', function () {
      languageSidebar.classList.add('open');
      wrapper.classList.remove('hidden');
   });

   closeSidebarBtn.addEventListener('click', function () {
      languageSidebar.classList.remove('open');
      wrapper.classList.add('hidden');
   });
}

function mediaContainer() {
   const mediaUrl = 'https://www.youtube.com/watch?v=gVgi5UtrxCQ';

   const container = document.getElementById('media-container');
   const overlayText = document.getElementById('overlay-text');

   const isYouTubeUrl = (url) => {
      return url.includes('youtube.com/watch') || url.includes('youtu.be');
   };

   const getYouTubeEmbedUrl = (url) => {
      const videoId = url.includes('youtu.be')
         ? url.split('/').pop()
         : new URLSearchParams(new URL(url).search).get('v');
      return `https://www.youtube.com/embed/${videoId}`;
   };

   const extension = mediaUrl.split('.').pop().toLowerCase().split(/\#|\?/)[0];
   const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
   const videoExtensions = ['mp4', 'webm', 'ogg'];

   if (container) {
      window.onload = function () {
          function showOverlay() {
              if (overlayText) {
                  overlayText.classList.add('show');
              }
          }
         if (isYouTubeUrl(mediaUrl)) {
            const iframe = document.createElement('iframe');
            if (iframe) {
               iframe.src = getYouTubeEmbedUrl(mediaUrl);
               iframe.allow =
                  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
               iframe.allowFullscreen = true;
               iframe.onload = showOverlay;
               container.appendChild(iframe);
            }
         } else if (imageExtensions.includes(extension)) {
            const img = document.createElement('img');
            img.src = mediaUrl;
            img.alt = 'Media Image';
            container.appendChild(img);
         } else if (videoExtensions.includes(extension)) {
            const video = document.createElement('video');
            video.src = mediaUrl;
            video.controls = true;
            video.autoplay = true;
            video.loop = true;
            container.appendChild(video);
         } else {
            container.innerText = 'Unsupported media type.';
         }
      };
   }
}

function footer() {
   const container = document.getElementById('footer-container');
   const dataFooter = container.getAttribute('data-language');
   const parsedFooterData = JSON.parse(dataFooter);
   const countrySelect = document.getElementById('country');
   const languageSelect = document.getElementById('language');
   const status = document.getElementById('languagestatus');
   const saveButton = document.getElementById('saveButton');
   const statusMobile = document.getElementById('languagestatusMobile');
   const defaultCountry = 'us';
   const defaultLanguage = 'en_US';
   let countryCode = document.documentElement.dataset.country;

   parsedFooterData.forEach((country) => {
      const option = document.createElement('option');
      option.value = country.code;
      option.textContent = country.name;
      countrySelect.appendChild(option);
   });

   let selectedCountry = parsedFooterData.find((c) => c.code === countryCode);
   if (!selectedCountry) {
      selectedCountry = parsedFooterData.find((c) => c.code === defaultCountry);
      countryCode = defaultCountry;
   }

   countrySelect.value = selectedCountry?.code;

   let lang = document.documentElement.lang.replace('-', '_');

   selectedCountry.languages.forEach((lang) => {
      const option = document.createElement('option');
      option.value = lang.code;
      option.textContent = lang.name;
      languageSelect.appendChild(option);
   });

   let langMatch = selectedCountry.languages.find((l) => l.code === lang);
   if (!langMatch) {
      langMatch = selectedCountry.languages.find(
         (l) => l.code === defaultLanguage
      );

      lang = defaultLanguage;
   }

   if (langMatch) {
      languageSelect.value = langMatch.code;
   } else {
      languageSelect.selectedIndex = 0;
   }

   updateLocaleAndCountry(countryCode, lang);

   // Update the locale and country
   function updateLocaleAndCountry(countryCode, languageCode) {
      const selectedCountryObject = parsedFooterData.find(
         (country) => country.code === countryCode
      );

      let selectedLanguageObject;
      if (selectedCountryObject) {
         selectedLanguageObject = selectedCountryObject.languages.find(
            (language) => language.code === languageCode
         );
      }
      const displayCountry = selectedCountryObject
         ? selectedCountryObject.name
         : countryCode;
      const displayLanguage = selectedLanguageObject
         ? selectedLanguageObject.name
         : languageCode;
      status.textContent = `${displayCountry} - ${displayLanguage}`;
      statusMobile.textContent = `${displayCountry} - ${displayLanguage}`;
   }

   // Update the languages values when the user change the country
   function updateLanguages(countryCode) {
      languageSelect.innerHTML = '';

      const selectedCountry = parsedFooterData.find(
         (c) => c.code === countryCode
      );
      if (!selectedCountry) return;
      selectedCountry.languages.forEach((lang) => {
         const option = document.createElement('option');
         option.value = lang.code;
         option.textContent = lang.name;
         languageSelect.appendChild(option);
      });
   }

    countrySelect.addEventListener('change', (e) => {
        updateLanguages(e.currentTarget.value);
    });

   // Saving all the changes
   saveButton.addEventListener('click', () => {
      const country = countrySelect.value;
      const language = languageSelect.value;
      setTimeout(() => {
         // get country and language selected
         const countrySelected = parsedFooterData.find(
            (c) => c.code === country
         );

         const languageSelected = countrySelected?.languages?.find(
            (c) => c.code === language
         );

         // Update UI
         updateLocaleAndCountry(country, language);
         document.cookie = `language=${language}; max-age=86400`;
         document.cookie = `country=${country}; max-age=86400`;
         // 86400 = 1 day
         languageSidebar.classList.remove('open');
         window.location.href = languageSelected.link;
      }, 1000);
   });
}

// Initialize Sections
function initializeTrends() {
   sideMenuBar();
   nextTrendButtons();
   mediaContainer();
   footer();
}

// Initialize on DOMContentLoaded
window.addEventListener('DOMContentLoaded', () => {
   initializeTrends();
});
